const AWIN_AFFID = '2820398';
const REVERB_AWIN_MID = '67144';

/**
 * Wrap a Reverb URL with Awin affiliate tracking.
 * Returns the original URL unchanged if affiliate config is missing.
 */
export function reverbAffiliateUrl(destinationUrl) {
  if (!AWIN_AFFID || !REVERB_AWIN_MID || !destinationUrl) return destinationUrl;
  return `https://www.awin1.com/cread.php?awinmid=${REVERB_AWIN_MID}&awinaffid=${AWIN_AFFID}&ued=${encodeURIComponent(destinationUrl)}`;
}
